export function amountCents(value) {
  const text = String(value ?? '').trim();
  if (!/^\d{1,18}(?:\.\d{1,2})?$/.test(text)) throw new Error('金额须为不超过两位小数的非负数');
  const [whole, fraction = ''] = text.split('.');
  return BigInt(whole) * 100n + BigInt(fraction.padEnd(2, '0'));
}
const centsText = cents => `${cents / 100n}.${String(cents % 100n).padStart(2, '0')}`;
export function formatPaymentMoney(value) {
  const [whole, fraction] = centsText(amountCents(value ?? '0')).split('.');
  return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}.${fraction}`;
}
export function editablePaymentLimit(available, row) {
  return centsText(amountCents(available) + (Number(row?.status) === 1 ? amountCents(row.paymentAmount) : 0n));
}
export function buildPaymentRequest(values, limit) {
  const payeeName = (values.payeeName || '').trim();
  if (!payeeName) throw new Error('请填写收款方');
  const amount = amountCents(values.paymentAmount);
  if (amount <= 0n) throw new Error('请款金额必须大于0');
  if (amount > amountCents(limit)) throw new Error('请款金额超过剩余可申请金额，请刷新后重试');
  return { payeeName, paymentAmount: centsText(amount), remark: (values.remark || '').trim() };
}
export function buildArchiveRequest(values, attachment) {
  const paymentDate = typeof values.paymentDate === 'string' ? values.paymentDate : values.paymentDate?.format('YYYY-MM-DD');
  const date = /^\d{4}-\d{2}-\d{2}$/.test(paymentDate || '') ? new Date(`${paymentDate}T00:00:00Z`) : null;
  if (!date || !Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== paymentDate) throw new Error('请选择有效的实际付款日期');
  if (!String(attachment || '').trim()) throw new Error('请上传付款凭证');
  return { paymentDate, paymentMethod: (values.paymentMethod || '').trim(), paymentNo: (values.paymentNo || '').trim(), attachment: attachment.trim() };
}
export function paymentStatus(status) {
  return ({ 1: { label: '待银行提交', color: 'orange' }, 2: { label: '凭证已归档', color: 'green' }, 3: { label: '已驳回', color: 'red' }, 4: { label: '银行已提交', color: 'blue' }, 5: { label: '银行已付款', color: 'cyan' }, 6: { label: '凭证已归档', color: 'green' }, 7: { label: '已撤回', color: 'default' } })[Number(status)] || { label: '未知状态', color: 'default' };
}
export function paymentActions(status, capabilities = {}) {
  const actions = ({ 1: ['edit', 'withdraw', 'submitBank', 'reject'], 4: ['confirmBankPaid'], 5: ['archiveVoucher'] })[Number(status)] || [];
  return actions.filter(action => capabilities[action]);
}
export function createPaymentScope() {
  let generation = 0;
  return { current: () => generation, invalidate: () => ++generation, isCurrent: value => value === generation };
}
export function createExpensePaymentClient(send) {
  return async (endpoint, body) => {
    const response = await send(`/companyExpenseInvoice/v1/authApi/${endpoint}`, body);
    if (!response?.data?.success) throw new Error(response?.data?.errorMessage || '费用请款操作失败');
    return response.data.module;
  };
}
export function matchingExpenseReceipt(records, payment) {
  if (!Array.isArray(records) || records.length !== 1 || !payment) return null;
  const record = records[0];
  if (record.direction !== 'out' || !record.payeeName?.trim() || record.payeeName.trim() !== payment.payeeName?.trim()) return null;
  // At 2^46 the distance between adjacent Numbers exceeds one cent.
  if (typeof record.amount === 'number' && record.amount >= 2 ** 46) return null;
  try { return amountCents(record.amount) === amountCents(payment.paymentAmount) ? record : null; }
  catch { return null; }
}
export function withExpensePaymentMenu(config, userID) {
  if (![2, 114].includes(Number(userID)) || config.some(item => item.path === '/CompanyExpenseInvoices' || item.children?.some(child => child.path === '/CompanyExpenseInvoices'))) return config;
  const entry = { name: '费用发票', path: '/CompanyExpenseInvoices' };
  const hasCompany = config.some(item => item.name === '公司管理');
  return hasCompany ? config.map(item => item.name === '公司管理' ? { ...item, children: [...(item.children || []), entry] } : item) : [...config, { name: '公司管理', icon: 'building', children: [entry] }];
}
